import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const TrelloCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrelloCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shortLink"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shortLink"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"None"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"TrelloCard","document":TrelloCardDocument}} as const;
export type TrelloCardQueryVariables = Types.Exact<{
  shortLink: Types.Scalars['ID'];
}>;


export type TrelloCardQuery = (
  { __typename: 'Query' }
  & { card?: Types.Maybe<(
    { __typename: 'Card' }
    & Pick<Types.Card, 'id' | 'url' | 'name'>
  )> }
);




/**
 * __useTrelloCardQuery__
 *
 * To run a query within a React component, call `useTrelloCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrelloCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrelloCardQuery({
 *   variables: {
 *      shortLink: // value for 'shortLink'
 *   },
 * });
 */
export function useTrelloCardQuery(baseOptions: Apollo.QueryHookOptions<TrelloCardQuery, TrelloCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrelloCardQuery, TrelloCardQueryVariables>(TrelloCardDocument, options);
      }
export function useTrelloCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrelloCardQuery, TrelloCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrelloCardQuery, TrelloCardQueryVariables>(TrelloCardDocument, options);
        }
export type TrelloCardQueryHookResult = ReturnType<typeof useTrelloCardQuery>;
export type TrelloCardLazyQueryHookResult = ReturnType<typeof useTrelloCardLazyQuery>;
export type TrelloCardQueryResult = Apollo.QueryResult<TrelloCardQuery, TrelloCardQueryVariables>;